<span *ngIf="count && count > 0" class="badge">{{ count }}</span>